import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Typography } from '@mui/material';
import React, { CSSProperties, FC } from 'react';
import { useTranslation } from 'react-i18next';

type EmptyConversationContentProps = {
  iconSize?: SizeProp,
  textColor?: CSSProperties["color"]
};

export const EmptyConversationContent: FC<EmptyConversationContentProps> = ({
  iconSize = '8x',
  textColor
}) => {
  const { t } = useTranslation();

  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{ flex: 1, marginTop: "3rem" }}
      spacing={2}
    >
      <Grid item>
        <FontAwesomeIcon icon="comment-dots" color="#78909C" size={iconSize} />
      </Grid>
      <Grid item>
        <Typography color="primary" variant="body1" style={textColor ? { color: textColor } : {}}>
          {t('questionsAndAnswers:prompt')}
        </Typography>
      </Grid>
    </Grid>
  );
};
